import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from 'contexts/AuthContext';
import { generateRandomState } from 'utils/auth';

const Login = () => {
  const { isAuthenticated, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    // If user is already authenticated, redirect them to the homepage.
    if (isAuthenticated()) {
      navigate('/');
      return;
    }

    // If not authenticated, proceed with login logic.
    const isLocalhost = window.location.hostname === 'localhost';

    if (isLocalhost) {
      // For localhost, simulate a successful login immediately.
      login();
      navigate('/');
    } else {
      // For production, redirect to the real IDP.
      try {
        const state = generateRandomState();
        const loginUrl = `${import.meta.env.VITE_IDP_BASE_URL}/login?response_type=code&client_id=${import.meta.env.VITE_CLIENT_ID}&redirect_uri=${encodeURIComponent(import.meta.env.VITE_REDIRECT_URI)}&scope=openid&state=${state}`;
        window.location.href = loginUrl;
      } catch {
        // Handle login initiation error silently or show user-friendly message
        // Optionally, show an error message to the user.
      }
    }
  }, [isAuthenticated, login, navigate]);

  // Render a loading/redirecting message.
  return <div>Loading...</div>;
};

export default Login;
